import React from 'react';
import { ClientResumeUpdateRequest } from '@common/model/client/resume/updateRequest';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import { SxProps } from '@cp/ds';

export class TariffsEditFormModel extends ClientResumeUpdateRequest {}

export interface TariffsEditProps {
  isSeparatedByChildrenCount: boolean;
  form: UseFormReturn<TariffsEditFormModel>;
  onSubmit: SubmitHandler<TariffsEditFormModel>;
  afterFields?: React.ReactNode;
  sx?: SxProps;
}
